import { defineComponent as _defineComponent } from 'vue'
import { ref, PropType } from 'vue'
import { SevenseasItem } from '@/templates/slplus/structure/questionModels'

import seaImage from '@/assets/tasks/sevenseas/sea.svg'
import coralImage from '@/assets/tasks/sevenseas/coraux.svg'
import fishImage from '@/assets/tasks/sevenseas/fish.svg'
import boatImage from '@/assets/tasks/sevenseas/Omar-boat1.svg'
import instructions from '@/assets/tasks/instructions.svg'

type SvgInHtml = HTMLElement & SVGGeometryElement


export default /*#__PURE__*/_defineComponent({
  __name: 'Fishing',
  props: {
  description: {
    type: String,
    default: '',
  },
  item: {
    type: Object as PropType<SevenseasItem>,
    required: true,
  },
},
  emits: ['done', 'playinstruction'],
  setup(__props, { expose, emit }) {
  expose();



const scrollElement = ref()
const boatElement = ref()
let boatSVGDocument: Document
const itemTop = ref(0)
const itemLeft = ref(0)
let fished = false

const done = () => {
  emit('done')
}

function randomIntFromInterval(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

// Set a random item location for left and right sides of the sea
// (scrollable area that is outside the current view)
const randomiseItemLocation = () => {
  const startX0 = 0 // Start of the left-hand invisible part of the sea
  const endX0: number = scrollElement.value.scrollLeft // End side of the left-hand invisible part of the sea
  const startX1: number = endX0 + scrollElement.value.clientWidth // Start of the right-hand invisible part of the sea
  const endX1: number = scrollElement.value.scrollWidth - 400 // End of the right-hand invisible sea
  const endY: number = scrollElement.value.clientHeight - Math.floor(scrollElement.value.clientHeight * 0.1) // Bottom of the viewport minus some buffering for the coral
  const startY = Math.floor(endY * 0.4) // Top of the viewport + some buffering for the sky & boat..

  const xIntervals = [
    [startX0, endX0],
    [startX1, endX1],
  ]
  const selectedXInterval = xIntervals[randomIntFromInterval(0, 1)]
  itemTop.value = randomIntFromInterval(startY, endY)
  itemLeft.value = randomIntFromInterval(selectedXInterval[0], selectedXInterval[1])
}

// After the SVG has loaded, calculate various dimensions
function svgLoaded() {
  const windowWidth = window.innerWidth
  const seaWidth = scrollElement.value.scrollWidth
  const startPosition = Math.floor(seaWidth / 2) - Math.floor(windowWidth / 2)
  scrollElement.value.scrollLeft = startPosition
  boatElement.value.style.left = `${startPosition + 100}px`
  const objectElement: HTMLObjectElement | null = document.getElementById('boat-image') as HTMLObjectElement
  if (objectElement && objectElement.contentDocument) {
    boatSVGDocument = objectElement.contentDocument
  }
  randomiseItemLocation()
}

const scroll = () => {
  if (fished) return
  const seaWidth = scrollElement.value.scrollWidth - 400
  const seaX = scrollElement.value.scrollLeft
  const scrollX = Math.round(seaX * 1.2) + 100
  boatElement.value.style.left = `${scrollX < seaWidth ? scrollX : seaWidth}px`
}

const fish = () => {
  fished = true
  const fishingLineElement = boatSVGDocument.getElementById('fishing-line') as SvgInHtml
  const fishingHookElement = boatSVGDocument.getElementById('fishing-hook') as SvgInHtml

  // Calculate the scaling factor between Parent Doc and SVG Doc
  const boatSVGElement = boatSVGDocument.getElementById('OmarsBoat') as SvgInHtml
  const SVGViewbox = boatSVGElement.getAttribute('viewBox')
  const SVGOriginalHeight = SVGViewbox ? parseFloat(SVGViewbox.split(' ')[3]) : 0
  const SVGScale = boatElement.value.clientHeight / SVGOriginalHeight // The scale of the boat to the entire screen size, before resizing the viewbox

  // Expand the viewbox of the SVG to accommodate the longer fishing line
  // Original boat viewbox value: boatSVGDocument.setAttribute('viewBox', '0 0 656 308')
  const boatDistanceFromTop = boatElement.value.offsetTop // Boat distance from top of screen (bottom side)
  const viewportHeightMinusBuffer = scrollElement.value.clientHeight - boatDistanceFromTop - Math.floor(scrollElement.value.clientHeight * 0.01) // Match the lowest point an item can be placed
  const newBoatViewboxHeight = viewportHeightMinusBuffer / SVGScale

  boatSVGElement.setAttribute('viewBox', '0 0 656 ' + newBoatViewboxHeight)

  // Transition the boat!
  boatElement.value.style.left = itemLeft.value + 25 + 'px'

  // When boat arrives, drop the fishing line
  setTimeout(() => {
    if (fishingLineElement && fishingHookElement) {
      // const lineheight = 242 + itemTop.value - boatDistanceFromTop
      const fishingLineLength = fishingLineElement.getTotalLength()
      // const scaledFishingLineLength = fishingLineLength * SVGScale // This is the length of the line translated to the SVG's parent Document
      // const lineY2 = boatElement.value.offsetTop + scaledFishingLineLength
      // const scaleY = itemTop.value / lineY2 // The ratio from  top of screen line vs item
      // fishingLineElement.setAttribute('y2', lineheight.toString())
      //fishingLineElement.setAttribute('style', `stroke-dasharray: ${lineheight.toString()}px; stroke-dashoffset: ${lineheight.toString()}px`)
      // fishingLineElement.setAttribute('transform', `translate(0 ${lineheight.toString()})`)

      const newL = itemTop.value - boatDistanceFromTop // new line length in parent coords
      const newLScaled = newL / SVGScale // new line length in SVG coords
      const scale = newLScaled / fishingLineLength // amount needed to scale the original line

      const newH = itemTop.value - boatDistanceFromTop // hook height in parent coords
      const newHScaled = Math.floor(newH / SVGScale - fishingLineLength) // new hook height in SVG coords

      fishingLineElement.style.transform = `scale(1, ${scale})`
      fishingHookElement.style.transform = `translate(0px, ${newHScaled}px)`

      setTimeout(() => {
        done()
      }, 2500)
    }
  }, 1000)
}

const __returned__ = { emit, scrollElement, boatElement, boatSVGDocument, itemTop, itemLeft, fished, done, randomIntFromInterval, randomiseItemLocation, svgLoaded, scroll, fish, seaImage, coralImage, fishImage, boatImage, instructions }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})